import styled from 'styled-components';


const SeparatorBullet = styled(({className}) => {

    return (
        <div className={className}>
            •
        </div>
    );
})`
  font-size: 7px;
  padding: 0 6px;
`;

export default SeparatorBullet;
